import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ClassView from "@/pages/ClassView";
import StudentProfile from "@/pages/StudentProfile";
import AdminPanel from "@/pages/AdminPanel";
import StudentPortal from "@/pages/StudentPortal";
import FamilyPortal from "@/pages/FamilyPortal";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Cargando…</div>;
  if (user === null) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => {
    const t = localStorage.getItem("cd-theme");
    if (t === "dark" || (!t && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
      document.documentElement.classList.add("dark");
    }
  }, []);
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portal/alumno" element={<StudentPortal />} />
            <Route path="/portal/familia" element={<FamilyPortal />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/clase/:id" element={<ClassView />} />
              <Route path="/clase/:id/alumno/:studentId" element={<StudentProfile />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
